import { Box } from "@mui/material";
import GridThumbnail from "./gridThumbnail";
import { IGridCellProps } from "./interfaces";

export const GridCell = ({
  columnIndex,
  rowIndex,
  style,
  data,
  onView,
  rowsSelected,
  setRowsSelected,
  lottoSelected,
  setLottoSelected,
  idsByLotto,
}: IGridCellProps) => {
  const item = data?.[rowIndex]?.[columnIndex];
  if (!item) return null;

  const idLotto = item.idLotto;

  const toggleLotto = () => {
    if (!idLotto) return;

    const idsDettaglio = idsByLotto.get(idLotto) ?? [];

    
    setLottoSelected((prev) =>
      prev.includes(idLotto) ? prev.filter((x) => x !== idLotto) : [...prev, idLotto]
    );

    
    setRowsSelected((prev) => {
      const allSelected =
        idsDettaglio.length > 0 && idsDettaglio.every((x) => prev.includes(x));

      if (allSelected) {
        return prev.filter((x) => !idsDettaglio.includes(x));
      }

      const set = new Set(prev);
      idsDettaglio.forEach((x) => set.add(x));
      return Array.from(set);
    });
  };

  return (
    <Box style={style} sx={{ p: 1, boxSizing: "border-box" }}>
      <GridThumbnail
        item={item}
        selected={lottoSelected.includes(idLotto)}   
        onSelect={toggleLotto}                       
        onView={() => onView(idLotto)}               
      />
    </Box>
  );
};
